import { TNormalizedQuestion } from 'src-new/components/lesson-task';

export const getEmptyQuestion = (number?: number): TNormalizedQuestion => {
    return {
        questionNumber: number ?? 1,
        questionsCount: 0,
        searchBlocksCount: 0,
    };
};
